import icons from './icons';

const constants = {
    icons
};

export default constants;


// WEBPACK FOOTER //
// ./src/Constants/index.js